import { FormRow, FormSection } from 'framework/ui/layout';
import {
  UPDATE_EMPLOYEE_MAIN_HR_INFORMATION,
  EmployeeTypeDropdown,
  PositionDropdown,
  EDUCATION_SPECIALIST_ID,
  SOFTWARE_ENGINEER_ID,
} from 'domain/shared/employee';
import EmployeeWorkplaceDropdown from 'domain/people/employee/shared/input/EmployeeWorkplaceDropdown';
import { TechnologyDropdown } from 'domain/shared/career';
import { getTechnologyFilter } from 'domain/shared/career';
import { FC } from 'react';
import { ClearAfterUnmountWrapper, useFormContext, TextInput } from 'framework/form';
import { FormFieldsData } from 'validation-schema-library/build/validation/types';

type HrInfoSectionUpdateSectionProps = {
  isGranted: (permission: string) => boolean;
  isVisibleOfficeLocation: (data: FormFieldsData) => boolean;
};

const HrInfoSectionUpdateSection: FC<HrInfoSectionUpdateSectionProps> = ({ isGranted, isVisibleOfficeLocation }) => {
  const { data } = useFormContext();
  const { positionId } = data || {};
  return (
    <FormSection title="HR information" isVisible={isGranted(UPDATE_EMPLOYEE_MAIN_HR_INFORMATION)}>
      <FormRow>
        <EmployeeTypeDropdown label="Type" source="employeeType" />
        <PositionDropdown source="positionId" label="Position" />
        <ClearAfterUnmountWrapper
          isVisible={employee => {
            return (
              Number(employee.positionId) === SOFTWARE_ENGINEER_ID ||
              Number(employee.positionId) === EDUCATION_SPECIALIST_ID
            );
          }}
        >
          <TechnologyDropdown
            customReduce={getTechnologyFilter(positionId)}
            deps={[positionId]}
            source="specializationInfo.technologyId"
            label="Technology"
          />
        </ClearAfterUnmountWrapper>
        <EmployeeWorkplaceDropdown source="extendedInformation.hrInformation.workplaceLocation" />
        <TextInput
          source="extendedInformation.hrInformation.roomNumber"
          label="Room number"
          isVisible={isVisibleOfficeLocation}
        />
        <TextInput
          source="extendedInformation.hrInformation.deskLocation"
          label="Desk location"
          isVisible={isVisibleOfficeLocation}
        />
        <TextInput source="extendedInformation.hrInformation.accessCardId" label="Access card ID" />
      </FormRow>
    </FormSection>
  );
};

export { HrInfoSectionUpdateSection };
